export const COUNTRY_OVERVIEW_ANALYTICS_FILTER =
  'COUNTRY_OVERVIEW_ANALYTICS_FILTER';
export const COUNTRY_OVERVIEW_MAP_SELECTION = 'COUNTRY_OVERVIEW_MAP_SELECTION';
export const COUNTRY_OVERVIEW_ANALYTICS_DATA =
  'COUNTRY_OVERVIEW_ANALYTICS_DATA';
export const COUNTRY_OVERVIEW_ENROLLMENT_DETAILS = 'ENROLLMENT_DETAILS';
export const GLOBAL_FILTER_SECTION = 'GLOBAL_FILTER_SECTION';
export const SITE_SECTION = 'SITE_SECTION';
export const COUNTRY_DETAILS_SLICER = 'COUNTRY_DETAILS_SLICER';
